'use strict';

module.exports = function (h, that) {
  var rows = [];
  var columns;
  var colIndex = -1;
  var rowIndex = -1;

  var editInput = require('./edit-cell-template')(h, that);
  var rowKey = that.opts.uniqueKey;

  var rowClass;
  var data = that.source == 'client' ? that.filteredData : that.tableData;

  data.map(function (row, index) {
    columns = [];
    rowIndex += 1;
    colIndex = -1;

    if (that.hasChildRow) {
      var childRowToggler = h('td', [h('span', {
        on: {
          'click': that.toggleChildRow.bind(that, row[rowKey])
        },
        'class': 'VueTables__child-row-toggler ' + that.childRowTogglerClass(row[rowKey]) })]);

      if (that.opts.childRowTogglerFirst) columns.push(childRowToggler);
    }

    that.allColumns.map(function (column) {
      colIndex += 1;
      var position = [rowIndex, colIndex];
      var type = 'text';

      var rowTemplate = that.$scopedSlots && that.$scopedSlots[column];
      var cellRef = 'R' + rowIndex + 'C' + colIndex;

      columns.push(h(
        'td',
        {
          ref: cellRef,
          'class': that.columnClass(column),
          on: {
            'mouseover': that.showCellPosition.bind(that, position),
            'click': that.editCell.bind(that, position)
          }
        },
        [h(
          'span',
          {
            directives: [{
              name: 'show',
              value: this.editCellShow(position)
            }]
          },
          [editInput(row, column, cellRef, position, type)]
        ), h(
          'span',
          {
            directives: [{
              name: 'show',
              value: !this.editCellShow(position)
            }]
          },
          [rowTemplate ? rowTemplate({ row: row, column: column, index: index }) : that.render(row, column, h)]
        )]
      ));
    }.bind(that));

    if (that.hasChildRow && !that.opts.childRowTogglerFirst) columns.push(childRowToggler);

    rowClass = that.opts.rowClassCallback ? that.opts.rowClassCallback(row) : '';

    rows.push(h(
      'tr',
      { 'class': rowClass,
        ref: 'R' + rowIndex,
        on: {
          'click': that.rowWasClicked.bind(that, row),
          'dblclick': that.rowWasClicked.bind(that, row)
        }
      },
      [columns]
    ));

    if (that.hasChildRow && this.rowsToggleState['row_' + row[rowKey]]) {

      var template = this._getChildRowTemplate(h, row);

      rows.push(h(
        'tr',
        { 'class': 'VueTables__child-row',
          ref: 'RC' + rowIndex },
        [h(
          'td',
          {
            ref: 'RCtd' + rowIndex,
            attrs: { colspan: that.allColumns.length + 1
            }
          },
          [template]
        )]
      ));
    }
  }.bind(that));

  return rows;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/template/rows.js